module.exports = __webpack_public_path__ + "8a5356e9/img/trash-icon.ff8201c7.svg";